'use strict'
import $ from 'jquery';
import Mustache from 'mustache';
import Promise from 'bluebird';
import listProgress from '../ui/list-progress';
import utils from '../util';

export default (API) => {
	API.orderList = ({ endpoint } = {}) => {
		API.log('INIT orderList');

		const partials = {
			item: $('#mustache-order-list-item').html(),
			trackingCodes: $('#mustache-tracking-codes').html(),
			products: $('#mustache-order-products').html()
		}

		const $container = $('.order-list');
		const limit = parseInt($container.data('limit'));
		const totalOrders = parseInt($container.data('total-count'));
		const offset = parseInt($container.data('offset'));
		const progressBar = listProgress('.list-progress-bar');

		let currentPage = 0;
		let progress = offset;

		const loadItems = () => {
			$container.addClass('loading');
			return Promise.resolve($.getJSON(endpoint, { page: currentPage, limit, offset }))
				.then(res => {
					const { orders } = res;
					if (orders) {
						const markup = Mustache.render('{{#orders}}{{>item}}{{/orders}}', { orders, renderPrice: utils.renderPrice }, partials);
						currentPage++;
						progress += orders.length;
						$container.find('.order-list-items').append(markup);
						$container.find('.progress').text(progress);
						progressBar.setProgress(progress / totalOrders);
						if (progress >= totalOrders) {
							$container.find('.load-more-button').hide();
						}
					}
				})
				.catch(console.error)
				.finally(() => $container.removeClass('loading'));
		}

		$container.on('click', '.load-more-button', loadItems);
	}
}
